/* =========================================================
   PRODUCT PAGE SHARED READ MORE / READ LESS

   Handles:
   - Product Description
   - Features
   - Technical Specs / Specifications

   Shared across all product templates.
   ========================================================= */

(function () {
  'use strict';


  /* =========================================================
     SETTINGS
     ========================================================= */

  /*
   * DESCRIPTION
   */
  var DESCRIPTION_DESKTOP_COLLAPSED_HEIGHT = 180;
  var DESCRIPTION_MOBILE_COLLAPSED_HEIGHT = 180;


  /*
   * FEATURES / TECHNICAL SPECS
   */
  var PRODUCT_INFO_DESKTOP_COLLAPSED_HEIGHT = 215;
  var PRODUCT_INFO_MOBILE_COLLAPSED_HEIGHT = 215;


  /*
   * General settings
   */
  var HEIGHT_TOLERANCE = 10;
  var BREAKPOINT = 750;



  /* =========================================================
     DEVICE CHECK
     ========================================================= */

  function isMobile() {
    return window.innerWidth < BREAKPOINT;
  }



  /* =========================================================
     VISIBILITY CHECK
     ========================================================= */

  function isVisible(element) {

    if (!element) {
      return false;
    }

    return window.getComputedStyle(element).display !== 'none';

  }



  /* =========================================================
     GET COLLAPSED HEIGHT
     ========================================================= */

  function getCollapsedHeight(section) {

    /*
     * Product Description
     */
    if (
      section.classList.contains(
        'product-description-expandable'
      )
    ) {

      return isMobile()
        ? DESCRIPTION_MOBILE_COLLAPSED_HEIGHT
        : DESCRIPTION_DESKTOP_COLLAPSED_HEIGHT;

    }


    /*
     * Features / Technical Specs
     */
    return isMobile()
      ? PRODUCT_INFO_MOBILE_COLLAPSED_HEIGHT
      : PRODUCT_INFO_DESKTOP_COLLAPSED_HEIGHT;

  }



  /* =========================================================
     RESET SECTION
     ========================================================= */

  function resetExpandable(item) {

    if (
      !item ||
      !item.content ||
      !item.toggle
    ) {
      return;
    }


    item.content.style.maxHeight = 'none';

    item.toggle.style.display = 'none';

    item.toggle.textContent =
      '+ READ MORE';

    item.toggle.setAttribute(
      'aria-expanded',
      'false'
    );


    if (item.section) {

      item.section.classList.remove(
        'expanded'
      );

    }

  }



  /* =========================================================
     SETUP EXPANDABLE
     ========================================================= */

  function setupExpandable(
    section,
    contentSelector,
    toggleSelector
  ) {

    /*
     * Skip hidden desktop/mobile duplicate.
     */
    if (
      !section ||
      !isVisible(section)
    ) {
      return;
    }


    var content =
      section.querySelector(
        contentSelector
      );


    var toggle =
      section.querySelector(
        toggleSelector
      );


    if (!content || !toggle) {
      return;
    }



    /*
     * Avoid duplicate event listeners
     * when reinitialized.
     */
    if (
      toggle._productExpandableHandler
    ) {

      toggle.removeEventListener(
        'click',
        toggle._productExpandableHandler
      );

    }



    var item = {

      section: section,

      content: content,

      toggle: toggle

    };


    resetExpandable(item);



    /*
     * Description and Product Information
     * can now have different heights.
     */
    var collapsedHeight =
      getCollapsedHeight(section);


    var fullHeight =
      content.scrollHeight;



    /* =========================================================
       SHORT CONTENT
       ========================================================= */

    if (
      fullHeight <=
      collapsedHeight + HEIGHT_TOLERANCE
    ) {

      content.style.maxHeight =
        'none';

      toggle.style.display =
        'none';

      return;

    }



    /* =========================================================
       INITIAL COLLAPSED STATE
       ========================================================= */

    content.style.maxHeight =
      collapsedHeight + 'px';


    toggle.style.display =
      'inline-block';



    /* =========================================================
       CLICK EVENT
       ========================================================= */

    var clickHandler =
      function () {


        var expanded =
          toggle.getAttribute(
            'aria-expanded'
          ) === 'true';



        /* =====================================================
           EXPAND
           ===================================================== */

        if (!expanded) {


          /*
           * Remove max height first so the
           * actual current height can be measured.
           */
          content.style.maxHeight =
            'none';


          var updatedHeight =
            content.scrollHeight;



          /*
           * Recalculate collapsed height
           * in case breakpoint changed.
           */
          collapsedHeight =
            getCollapsedHeight(section);



          /*
           * Put it back into collapsed state
           * temporarily so CSS transition works.
           */
          content.style.maxHeight =
            collapsedHeight + 'px';



          /*
           * Force browser repaint.
           */
          void content.offsetHeight;



          /*
           * Expand to full height.
           */
          content.style.maxHeight =
            updatedHeight + 'px';


          section.classList.add(
            'expanded'
          );


          toggle.textContent =
            '- READ LESS';


          toggle.setAttribute(
            'aria-expanded',
            'true'
          );


        }


        /* =====================================================
           COLLAPSE
           ===================================================== */

        else {


          collapsedHeight =
            getCollapsedHeight(section);


          content.style.maxHeight =
            collapsedHeight + 'px';


          section.classList.remove(
            'expanded'
          );


          toggle.textContent =
            '+ READ MORE';


          toggle.setAttribute(
            'aria-expanded',
            'false'
          );


        }

      };



    /*
     * Save handler reference so it
     * can be removed during resize.
     */
    toggle._productExpandableHandler =
      clickHandler;


    toggle.addEventListener(
      'click',
      clickHandler
    );

  }



  /* =========================================================
     INITIALIZE ALL SECTIONS
     ========================================================= */

  function initializeAll() {


    /* =========================================================
       DESCRIPTION
       ========================================================= */

    document
      .querySelectorAll(
        '.product-description-expandable'
      )
      .forEach(function (section) {


        setupExpandable(
          section,
          '.product-description-expandable__content',
          '.product-description-expandable__toggle'
        );


      });



    /* =========================================================
       FEATURES / TECHNICAL SPECS
       ========================================================= */

    document
      .querySelectorAll(
        '.expandable'
      )
      .forEach(function (section) {


        setupExpandable(
          section,
          '.expandable__content',
          '.expandable__toggle'
        );


      });

  }



  /* =========================================================
     INIT
     ========================================================= */

  function init() {


    initializeAll();



    /*
     * Track desktop/mobile breakpoint.
     */
    var previousMobileState =
      isMobile();


    var resizeTimer;



    /* =========================================================
       RESIZE
       ========================================================= */

    window.addEventListener(
      'resize',
      function () {


        window.clearTimeout(
          resizeTimer
        );


        resizeTimer =
          window.setTimeout(
            function () {


              var currentMobileState =
                isMobile();



              /*
               * Reinitialize only when crossing
               * desktop/mobile breakpoint.
               */
              if (
                currentMobileState ===
                previousMobileState
              ) {
                return;
              }


              previousMobileState =
                currentMobileState;


              initializeAll();


            },
            100
          );


      }
    );



    /* =========================================================
       WINDOW LOAD
       =========================================================
       Recalculate after fonts/images/apps load.
       ========================================================= */

    window.addEventListener(
      'load',
      function () {

        initializeAll();

      }
    );

  }



  /* =========================================================
     START
     ========================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }

})();